import { auswahlZusammenfuehren } from '../../services/mangelKatalog/zusammenfuehren';
import type { KatalogAuswahl, MerkSchluessel } from '../../services/mangelKatalog/typen';

/**
 * Korb der Mehrfachauswahl (Paket L, 30.09.): Gedrückthalten legt einen
 * Standardmangel in den Korb bzw. nimmt ihn heraus; solange der Korb nicht
 * leer ist, schaltet auch ein kurzer Tipp um. „Übernehmen“ führt alles zu
 * EINEM Mangel zusammen (auswahlZusammenfuehren). Der Korb bleibt beim
 * Wechsel von Gruppe, Kategorie, Suche und Merkliste erhalten.
 */

export interface KorbEintrag {
    /** knoten:<id> | eintrag:<eintragId> (schluesselVon). */
    schluessel: MerkSchluessel;
    auswahl: KatalogAuswahl;
    /** Kurzname für die Sammelleiste. */
    kurz: string;
}

/** Nur Standardmängel mit Vorlage kommen in den Korb (kein Freitext). */
export const korbfaehig = (a: KatalogAuswahl): boolean => a.art !== 'freitext' && !!a.vorlage;

/** Hinein, wenn noch nicht drin; sonst heraus. Nicht korbfähig → unverändert. */
export function korbUmschalten(korb: readonly KorbEintrag[], e: KorbEintrag): readonly KorbEintrag[] {
    if (!e.schluessel || !korbfaehig(e.auswahl)) return korb;
    return korb.some((k) => k.schluessel === e.schluessel)
        ? korb.filter((k) => k.schluessel !== e.schluessel)
        : [...korb, e];
}

export function korbSchluessel(korb: readonly KorbEintrag[]): ReadonlySet<MerkSchluessel> {
    return new Set(korb.map((k) => k.schluessel));
}

/** Korb → eine Auswahl (Reihenfolge der Auswahl); leer → null. */
export function korbUebernehmen(korb: readonly KorbEintrag[]): KatalogAuswahl | null {
    return auswahlZusammenfuehren(korb.map((k) => k.auswahl));
}
